import type { FaireProductEntity } from "../../entity_types/product";

export const p_ur2s5exw8g: FaireProductEntity = {
  token: "p_ur2s5exw8g",
  type: "product",
  name: "Milka Chips Ahoy 100g (European)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/c424c8ff10f8083efa4628501e4df89e3d0c08810cc1c36fb8ad0c6d2e976f9e.jpeg",
  galleryImageUrls: [],
  priceDollars: 3.26,
  description:
    "Experience the perfect fusion of chocolate and cookies with Milka Chips Ahoy!, a European fan favorite. This delicious bar combines Milka’s silky Alpine milk chocolate with crunchy Chips Ahoy! cookie pieces and a smooth chocolate cream filling. Every bite delivers a satisfying mix of creamy, crunchy, and chocolaty goodness — a treat that cookie lovers can’t resist.\n\n✅ Authentic Milka chocolate bar from Europe\n✅ Made with Alpine milk chocolate and real Chips Ahoy! cookie pieces\n✅ Smooth chocolate cream filling for rich texture and taste\n✅ Perfect for gifting, sharing, or a sweet snack anytime\n\nSweet, crunchy, and creamy all at once, Milka Chips Ahoy! (Europe Edition) brings together two iconic treats — Milka chocolate and Chips Ahoy! cookies — for a one-of-a-kind indulgence.\n",
  tags: [],
  msrpDollars: 6.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:26.643Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
